export default __webpack_public_path__ + "static/media/3.364eeaa8.jpg";